// extracted by mini-css-extract-plugin
module.exports = {"container":"container-2nF7w","title":"title-3OrVB"};